document.getElementById('customer-registration-form')
    ?.addEventListener("submit", (event) => {
            event.preventDefault();
            let form = event.target;

            if(!(form instanceof HTMLFormElement) || form.disabled) {
                return;
            }

            form.disabled = true;
            setTimeout(() => {
                form.disabled = false;
            }, 2000);

            form.submit();
        }
    );
